import { useContext } from "react";
import { useMutation } from "react-query";
import AppContext from "../../../../../AppContext";
import { Account } from "../../../../../types";
import AvatarPresenter from "./AvatarPresenter";

export default function AvatarContainer() {
  const { reloadAccount, account } = useContext(AppContext);

  const { mutate: updateAvatarMutation, isLoading: isAvatarUpdating } = useMutation((file: File) => {
    const formData = new FormData();
    formData.append('ImageFile', file);

    return fetch(`/api/account/avatar`, {
      method: 'POST',
      body: formData,
    })
  }, { onSuccess: () => reloadAccount() });

  const { mutate: updateCoverMutation, isLoading: isCoverUpdating } = useMutation((file: File) => {
    const formData = new FormData();
    formData.append('ImageFile', file);

    return fetch(`/api/account/background`, {
      method: 'POST',
      body: formData,
    })
  }, { onSuccess: () => reloadAccount() });

  const { mutate: deleteAvatarMutation, isLoading: isAvatarDeleting } = useMutation(
    () => fetch(`/api/account/avatar`, { method: 'DELETE' }),
    { onSuccess: () => reloadAccount() }
  );

  const handleAvatarChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      updateAvatarMutation(file);
    }
    event.target.value = '';
  };

  const handleCoverChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      updateCoverMutation(file);
    }
    event.target.value = '';
  };

  const handleAvatarDelete = () => deleteAvatarMutation();

  return <AvatarPresenter
    handleAvatarChange={handleAvatarChange}
    handleAvatarDelete={handleAvatarDelete}
    handleCoverChange={handleCoverChange}
    avatarUrl={(account as Account).avatarUrl}
    coverUrl={(account as Account).backgroundUrl}
    avatarIsLoading={isAvatarUpdating || isAvatarDeleting}
    coverIsLoading={isCoverUpdating}
  />;
}
